export const PRODUCT_CATEGORIES = {
  DISCOUNT: 'discount',
  EXTRA: 'extra',
  MAIN: 'main',
  PAYMENT: 'payment',
  PAYMENT_RELATED: 'payment related',
  SERVICE_CC: 'service',
  SERVICE_PACKAGE: 'service package',
};
